module.exports = __webpack_public_path__ + "img/lens-160-minus-09.43ec57ee.png";